import getLocalString from "constants/Localization";
import { MenuItem } from "@mui/material";
import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";
import { AdditionalCost } from "generated/graphql";
import { GlobalMessage } from "hooks/notifications/useGlobalMessage";
import useDeleteAdditionalCost from "hooks/organization/useDeleteAdditionalCost";
import useConfirmationDialog from "hooks/useConfirmationDialog";
import { useCallback } from "react";

export default function Delete({
  closeMenu,
  id,
}: {
  closeMenu: () => void;
  id: AdditionalCost["id"];
}) {
  const [deleteAdditionalCost, { isSuccess }] = useDeleteAdditionalCost();

  const acceptFn = useCallback(async (): Promise<GlobalMessage> => {
    const { data } = await deleteAdditionalCost({ id });

    if (isSuccess(data)) {
      closeMenu();
      return { message: getLocalString("organization.delete-additional-cost-success") };
    } else {
      return {
        message: getLocalString("organization.delete-additional-cost-failure"),
        options: { variant: "error" },
      };
    }
  }, [deleteAdditionalCost, id]);

  const cancelFn = useCallback(async () => {
    closeMenu();
    return true;
  }, []);

  const { open, setOpen, onAccept, onCancel } = useConfirmationDialog({
    acceptFn,
    cancelFn,
  });

  return (
    <>
      <ActionConfirmDialog
        open={open}
        setOpen={setOpen}
        handleAccept={onAccept}
        handleCancel={onCancel}
        title="Confirmation"
        content="Are you sure you want to delete this additional cost?"
      />
      <MenuItem onClick={() => setOpen(true)}>Delete</MenuItem>
    </>
  );
}
